/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseMediaContentSectionFragment, MediaContentSectionFragment, FullMediaContentSectionFragment} from '@amblique/contentful/app/contentful/fragments/media-content-section';

/**
 * Get a single MediaContentSection by ID (base - scalars only)
 */
export const getBaseMediaContentSectionById = gql`
  ${BaseMediaContentSectionFragment}

  query GetBaseMediaContentSectionById($id: String!, $locale: String!, $preview: Boolean) {
    mediaContentSection(id: $id, locale: $locale, preview: $preview) {
      ...BaseMediaContentSectionFragment
    }
  }
`;

/**
 * Get a single MediaContentSection by ID (standard - 1 level deep)
 */
export const getMediaContentSectionById = gql`
  ${MediaContentSectionFragment}

  query GetMediaContentSectionById($id: String!, $locale: String!, $preview: Boolean) {
    mediaContentSection(id: $id, locale: $locale, preview: $preview) {
      ...MediaContentSectionFragment
    }
  }
`;

/**
 * Get a single MediaContentSection by ID (full - 2 levels deep)
 */
export const getFullMediaContentSectionById = gql`
  ${FullMediaContentSectionFragment}

  query GetFullMediaContentSectionById($id: String!, $locale: String!, $preview: Boolean) {
    mediaContentSection(id: $id, locale: $locale, preview: $preview) {
      ...FullMediaContentSectionFragment
    }
  }
`;

/**
 * Get all MediaContentSection entries with pagination (base - scalars only)
 */
export const getBaseMediaContentSections = gql`
  ${BaseMediaContentSectionFragment}

  query GetBaseMediaContentSections(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [MediaContentSectionOrder]
    $where: MediaContentSectionFilter
    $preview: Boolean
  ) {
    mediaContentSectionCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseMediaContentSectionFragment
      }
    }
  }
`;

/**
 * Get all MediaContentSection entries with pagination (standard - 1 level deep)
 */
export const getMediaContentSections = gql`
  ${MediaContentSectionFragment}

  query GetMediaContentSections(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [MediaContentSectionOrder]
    $where: MediaContentSectionFilter
    $preview: Boolean
  ) {
    mediaContentSectionCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...MediaContentSectionFragment
      }
    }
  }
`;

/**
 * Get all MediaContentSection entries with pagination (full - 2 levels deep)
 */
export const getFullMediaContentSections = gql`
  ${FullMediaContentSectionFragment}

  query GetFullMediaContentSections(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [MediaContentSectionOrder]
    $where: MediaContentSectionFilter
    $preview: Boolean
  ) {
    mediaContentSectionCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullMediaContentSectionFragment
      }
    }
  }
`;
